module.exports = new __parcel__URL__("Illustration.bc0cbd7b.svg").toString();